<template>
    <div align="left">
        <span v-if="isSATandRESET" class="mapBoxTtLevles mg_left_0">{{ props.one.level }} {{ props.one.passageNumber }}</span>
        <div v-if="isSATandRESET" class="barVertical" />
        <!-- <q-chip square outline color="primary" size="md">{{ props.one.redirectKey }}</q-chip> -->
        <span v-if="isSATandRESET" class="mapBoxTtMoon">수능모의평가</span>
        <span v-if="!isSATandRESET" class="mapBoxTtMoon mg_left_0">진단평가</span>
        <!-- <span v-if="props.type === 'SAT' ? '진단평가'" class="mapBoxTtNormal" style="margin: 0">{{ props.type === 'SAT' ? '수능모의평가' : '진단평가' }} </span> -->
        <!-- <div class="barVertical" />
        <span class="txtNormal q-px-xs">{{ props.one.passageArea }} &nbsp;&nbsp;{{ props.one.passageNumber }} &nbsp;&nbsp;&nbsp;{{ props.one.passageClass }} &nbsp;&nbsp;&nbsp;{{ props.one.passageName }}</span> -->
    </div>
</template>
<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
// {
//             “level”: “1 레벨“,
//             “passageNumber”: “1회차“,
//             “redirectKey”: 3040
//           }
const props = defineProps({
    type: {
        Type: Object,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

const isSATandRESET = computed(() => {
    return props.type === 'SAT' || props.type === 'SAT_RESET';
});
// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

// const kind = computed(() => props.kind);

onMounted(() => {
    // console.log('--one-props-', props.one);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss"></style>
